import { TypedValue } from '@multiversx/sdk-core/out';
import { rawVestaContract } from '.';
import { proxyNetworkProvider, resultsParser } from '..';

export const getSnapshot = async (address: string) => {
  const query = rawVestaContract.methods
    .getSnapshot([address])
    .check()
    .buildQuery();
  const response = await proxyNetworkProvider.queryContract(query);
  const { firstValue, returnCode } = resultsParser.parseQueryResponse(
    response,
    rawVestaContract.getEndpoint('getSnapshot')
  );
  if (!returnCode.isSuccess()) {
    return [];
  } else {
    return parseResult(firstValue?.valueOf() ?? []);
  }
};

const parseResult = (value: any[]): SnapshotEntry[] => {
  const parsed = value.map((v) => ({
    epoch: v[0].toNumber(),
    snapshotInfo: parseSnapshotInfo(v[1])
  }));
  return parsed;
};

const parseSnapshotInfo = (v: any): SnapshotInfo => ({
  lp_vegld_amount: v.lp_vegld_amount.toString(),
  pool_weight: v.pool_weight.toString(),
  weighted_amount: v.weighted_amount.toString(),
  min_vegld_liquidity_treshold: v.vegld_earn_treshold.toString()
});

export interface SnapshotEntry {
  epoch: number;
  snapshotInfo: SnapshotInfo;
}

export interface SnapshotInfo {
  lp_vegld_amount: string;
  pool_weight: string;
  weighted_amount: string;
  min_vegld_liquidity_treshold: string;
}
